import { AdjustmentType, RoundingType } from '../../types/price.types';

export const PRICE_BAND_AUTOMATIONS = 'Price Band Automations';
export const CHANNEL_AUTOMATIONS = 'Channel Automations';
export const PRICE_BAND_AUTOMATIONS_DESCRIPTION = 'Automate pricing adjustments for your price bands.';
export const CHANNEL_AUTOMATIONS_DESCRIPTION = 'Automate pricing adjustments for your channels.';
export const CREATE_PRICE_BAND = '+ Create Price Band';
export const CREATE_CHANNEL_RULE = '+ Create Channel Rule';
export const CREATE_PRICE_BAND_FIRST = 'Go to price bands and create your first price band';
export const CREATE_CHANNEL_FIRST = 'Go to Admin and start adding channels to your brand';
export const GO_TO_PRICE_BANDS = 'Go to price bands';
export const GO_TO_ADMIN = 'Go to Admin';
export const NOT_APPLICABLE = 'N/A';
export const NO_CHANNEL_RULE_DEFINED = 'No channel rule defined';
export const ADJUSTMENT_COPY = {
  [AdjustmentType.NONE]: 'No Calculation',
  [AdjustmentType.PERCENTAGE]: 'Percentage',
  [AdjustmentType.FIXED]: 'Fixed',
};
export const ROUNDING_COPY = {
  [RoundingType.NONE]: 'No Rounding',
  [RoundingType.DOWN]: 'Round Down',
  [RoundingType.UP]: 'Round Up',
  [RoundingType.NEAREST]: 'Nearest',
};
